var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.826 12.366H14.458V14.298C14.6447 14.0927 14.906 13.9247 15.242 13.794C15.578 13.6633 15.942 13.598 16.334 13.598C17.034 13.598 17.6127 13.7567 18.07 14.074C18.5367 14.3913 18.8773 14.802 19.092 15.306C19.3067 15.81 19.414 16.356 19.414 16.944C19.414 18.036 19.106 18.904 18.49 19.548C17.874 20.1827 17.006 20.5 15.886 20.5C15.1393 20.5 14.4907 20.374 13.94 20.122C13.3893 19.8607 12.9647 19.5013 12.666 19.044C12.3673 18.5867 12.204 18.0593 12.176 17.462H14.514C14.57 17.7513 14.7053 17.994 14.92 18.19C15.1347 18.3767 15.4287 18.47 15.802 18.47C16.2407 18.47 16.5673 18.33 16.782 18.05C16.9967 17.77 17.104 17.3967 17.104 16.93C17.104 16.4727 16.992 16.1227 16.768 15.88C16.544 15.6373 16.2173 15.516 15.788 15.516C15.4707 15.516 15.2093 15.5953 15.004 15.754C14.7987 15.9033 14.6633 16.104 14.598 16.356H12.288V10.266H18.826V12.366Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFive);
export default __webpack_public_path__ + "static/media/five.9f8738e67d7ea8952759fbe8a3364a78.svg";
export { ForwardRef as ReactComponent };